import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { useEffect } from "react"

import { cleanEmptyParams } from "@/utilities/etc"
import { confirmPaymentIntentQueryOptions } from "@/utilities/hooks/queries/payment"
import WelcomeTokenStorage from "@/utilities/WelcomeTokenStorage"

export const Route = createFileRoute(
  "/qr/$qrLookupID/gated/$pamID/$sessionID/payment-status"
)({
  staticData: {
    pageName: "Payment Status",
  },
  validateSearch: (
    search: Record<string, unknown>
  ): {
    payment_intent?: string
    payment_intent_client_secret?: string
    redirect_status?: string
  } => {
    return cleanEmptyParams({
      payment_intent: (search.setup_intent as string) || "",
      payment_intent_client_secret:
        (search.setup_intent_client_secret as string) || "",
      redirect_status: (search.redirect_status as string) || "",
    })
  },
  beforeLoad: async ({ params, search }) => {
    if (
      !search.payment_intent ||
      !search.payment_intent_client_secret ||
      search.redirect_status !== "succeeded"
    ) {
      throw redirect({
        to: "/qr/$qrLookupID/gated/$pamID/$sessionID/checkout",
        params,
        search: { paymentStatus: "failed" },
        replace: true,
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { payment_intent } = Route.useSearch()
  const { pamID } = Route.useParams()
  const navigate = Route.useNavigate()

  const { data } = useSuspenseQuery(
    confirmPaymentIntentQueryOptions({
      stripePaymentIntentID: payment_intent!,
      pamID,
    })
  )

  WelcomeTokenStorage.removeToken()

  useEffect(() => {
    navigate({
      to: "/receipt/$receiptID",
      params: { receiptID: data.receiptID },
      replace: true,
    })
  }, [data])
}
